/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SegmentInputs */

const cs_field_segment = /** @type {(inputs: Field_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

const en_field_segment = /** @type {(inputs: Field_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

/**
* | output |
* | --- |
* | "Segment" |
*
* @param {Field_SegmentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_segment = /** @type {((inputs?: Field_SegmentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SegmentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_segment(inputs)
	return cs_field_segment(inputs)
});